import React from "react";

function Searchbar(props) {
	const border = props.bordered ? "1px solid #000" : "none";
	return (
		<div className="form-group has-search mt-2" style={{ border: border, display: 'flex', flexDirection: 'row' }}>
			<input
				type="text"
				className="form-control w-100 shadow-none"
				placeholder="Search..."
				autoComplete="new-password"
				value={props.keyword}
				onChange={e => props.onChange(e.target.value)} />
			<span className="fa fa-search form-control-feedback"></span>
		</div>
	);
}

export default Searchbar;
